/**
 * KAN-303: голосовой пакет — клиент API кабинета.
 */
import apiClient from './client';
import type { CallCharge, TariffPlan, VoiceBalance } from '../../types/voiceBilling';
import type { OrganizationSubscription } from '../../types/subscription';
import type { PaginatedResponse } from '../../types/billing';

export const voiceBillingApi = {
  /** Остаток пакета и состояние. */
  getBalance: async (): Promise<VoiceBalance> => {
    const response = await apiClient.get<VoiceBalance>('/api/v1/billing/voice/balance/');
    return response.data;
  },

  /** История списаний за звонки, включая нетарифицируемые. */
  getCharges: async (params?: { page?: number }): Promise<PaginatedResponse<CallCharge>> => {
    const response = await apiClient.get<PaginatedResponse<CallCharge>>(
      '/api/v1/billing/voice/charges/',
      { params }
    );
    return response.data;
  },

  /** Тарифы, доступные к покупке. */
  getPlans: async (): Promise<TariffPlan[]> => {
    const response = await apiClient.get<TariffPlan[]>('/api/v1/billing/plans/');
    return response.data;
  },

  /**
   * KAN-989: купить тариф с кошелька кабинета. Ответ 200 с подпиской;
   * 402 {detail, code: "insufficient_funds"} при нехватке денег;
   * 409 при другом оплаченном тарифе (KAN-342).
   */
  subscribe: async (planId: string): Promise<OrganizationSubscription> => {
    const response = await apiClient.post<OrganizationSubscription>(
      `/api/v1/billing/plans/${planId}/subscribe/`
    );
    return response.data;
  },
};
